module.exports = __webpack_public_path__ + "img/aphis-gossypii.6ff71817.jpg";